// extracted by mini-css-extract-plugin
export default {"file_detail":"index_file_detail__b0Km-","release_note":"index_release_note__Lk20A"};